import React, { Component } from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import FullTable from "components/FullTable"
import _ from "lodash"
import Title from "../general/title"
import clone from "clone"
import times from "helpers/times"
import Switch from "react-switch"
import helpers from "helpers/helpers"
import settings from 'settings'

class HomeConstructionStatus extends Component {
	constructor(props) {
		super(props)
		this.state = {
			filters: {},
			times: times(),
			dataModel: {
				starts: 0,
				completed: 0,
				closed: 0,
				total: 0,
			},
			builderLotType: [],
			lotType: [],
			columns: [
				{
					Header: "Lot Type",
					accessor: "lot_type",
					filterMethod: (f, r) => helpers.tableText(f, r, "lot_type"),
				},
				{
					Header: "Subdivision",
					accessor: "sub",
					filterMethod: (f, r) => helpers.tableText(f, r, "sub"),
				},
				{
					Header: `${_.get(settings, "renames.section") || "Section"}`,
					accessor: "section",
					filterMethod: (f, r) => helpers.tableText(f, r, "section"),
				},
				{
					Header: "Builder",
					accessor: "builder",
					filterMethod: (f, r) => helpers.tableText(f, r, "builder"),
				},
				{
					Header: _.get(settings, "renames.starts") || "Starts",
					accessor: "starts",
					className: "right",
					Footer: (props) => {
						let total = 0
						_.forEach(props.data, (v) => {
							total += v.starts
						})
						if (typeof total == "number") {
							return total.toLocaleString()
						}
						return total
					},
				},
				{
					Header: "Completed",
					accessor: "completed",
					className: "right",
					Footer: (props) => {
						let total = 0
						_.forEach(props.data, (v) => {
							total += v.completed
						})
						if (typeof total == "number") {
							return total.toLocaleString()
						}
						return total
					},
				},
				{
					Header: "Closed to Homebuyer",
					accessor: "closed",
					className: "right",
					Footer: (props) => {
						let total = 0
						_.forEach(props.data, (v) => {
							total += v.closed
						})
						if (typeof total == "number") {
							return total.toLocaleString()
						}
						return total
					},
				},
				{
					Header: "Total",
					accessor: "total",
					className: "right",
					Footer: (props) => {
						let total = 0
						_.forEach(props.data, (v) => {
							total += v.total
						})
						if (typeof total == "number") {
							return total.toLocaleString()
						}
						return total
					},
				},
			],
			lotTypeColumns: [
				{
					Header: "Lot Type",
					accessor: "lot_type",
				},
				{
					Header: _.get(settings, "renames.starts") || "Starts",
					accessor: "starts",
					className: "right",
					Footer: (props) => {
						let total = 0
						_.forEach(props.data, (v) => {
							total += v.starts
						})
						if (typeof total == "number") {
							return total.toLocaleString()
						}
						return total
					},
				},
				{
					Header: "Completed",
					accessor: "completed",
					className: "right",
					Footer: (props) => {
						let total = 0
						_.forEach(props.data, (v) => {
							total += v.completed
						})
						if (typeof total == "number") {
							return total.toLocaleString()
						}
						return total
					},
				},
				{
					Header: "Closed to Homebuyer",
					accessor: "closed",
					className: "right",
					Footer: (props) => {
						let total = 0
						_.forEach(props.data, (v) => {
							total += v.closed
						})
						if (typeof total == "number") {
							return total.toLocaleString()
						}
						return total
					},
				},
				{
					Header: "Total Lots",
					accessor: "total",
					className: "right",
					Footer: (props) => {
						let total = 0
						_.forEach(props.data, (v) => {
							total += v.total
						})
						if (typeof total == "number") {
							return total.toLocaleString()
						}
						return total
					},
				},
			],
			active: false,
		}
	}

	filterChange = e => {
		let state = clone(this.state)
		state.filters[e.target.value] = !state.filters[e.target.value]
		this.setState(state)
	}

	toggleAll = checked => {
		let filters = clone(this.state.filters)
		_.forEach(filters, (v, k) => {
			filters[k] = checked
		})
		this.setState({ filters: filters })
	}

	buildData = () => {
		let store = {}
		let property = _.find(this.props.payload.public.properties, {id: parseInt(this.props.activeProperties[0])})
		_.forEach(this.props.payload.exec.lots, v => {
			// If only active builders set, skip past ones that are in the active builders list.
			if(this.state.active && _.has(property, `activeBuilders`) && !property.activeBuilders.includes(v.builder)) {
				return
			}
			let type = _.find(this.props.payload.public.lot_types, { id: v.lot_type })
			let builder = _.find(this.props.payload.public.builders, { id: v.builder })

			if (!type) {
				//console.log("No type found for lot", v.address)
				return
			}
			else if (!builder) {
				//console.log("No builder found for lot", v.address)
				return
			}
			if(builder.name) builder.name = helpers.safeBuilderName(builder.name)
			let path = `["${type.name}"]["${builder.name}"]["${v.section_id}"]`
			if (!_.has(store, path)) {
				let model = clone(this.state.dataModel)
				_.setWith(store, path, model, Object)
			}
			store[type.name][builder.name][v.section_id].sub = v.sub_name
			store[type.name][builder.name][v.section_id].section = v.section_name
			if (v.closing_date) {
				store[type.name][builder.name][v.section_id].closed++
			}
			else if (v.complete_date) {
				store[type.name][builder.name][v.section_id].completed++
			}
			else if (v.start_date) {
				store[type.name][builder.name][v.section_id].starts++
			}
		})
		_.forEach(store, (builders) => {
			_.forEach(builders, (sizes) => {
				_.forEach(sizes, (v) => {
					v.total = v.starts + v.completed + v.closed
				})
			})
		})
		return store
	}

	buildTable() {
		let store = this.buildData()
		let data = []

		_.forEach(store, (builder, lotType) => {
			_.forEach(builder, (sizes, builderName) => {
				_.forEach(sizes, v => {
					data.push({
						lot_type: lotType,
						sub: v.sub,
						section: v.section,
						builder: builderName,
						starts: v.starts,
						completed: v.completed,
						closed: v.closed,
						total: v.total,
					})
				})
			})
		})
		return data
	}

	buildLotTypeTable() {
		let store = this.buildData()
		let data = []
		let ret = {}
		_.forEach(store, (builder, lotType) => {
			let typeTotals = clone(this.state.dataModel)
			_.forEach(builder, section => {
				_.forEach(section, v => {
					typeTotals.starts += v.starts
					typeTotals.completed += v.completed
					typeTotals.closed += v.closed
					typeTotals.total += v.total
				})
				ret[lotType] = typeTotals
			})
		})
		_.forEach(ret, (v, lotType) => {
			//_.forEach()
			data.push({
				lot_type: lotType,
				sub: v.sub,
				starts: v.starts,
				completed: v.completed,
				closed: v.closed,
				total: v.total,
			})
		})
		return data
	}

	toggle = () => {
		this.setState({active: !this.state.active})
	}

	render() {
		if (!this.props.payloadStatus) {
			return ""
		} else if (this.props.activeProperties.length > 1) {
			return <h1 className="chooseError">Please choose only one property.</h1>
		} else {
			return (
				<div className="sales">
					<div className="imageGroup">
						<Title title="Home Construction Status" showDate={false} cutPadding={true} />
						<div className="content">
							<div className="switch my-3" onClick={(e) => e.stopPropagation()}>
								<Switch
									onChange={this.toggle}
									checked={this.state.active}
									checkedIcon={false}
									uncheckedIcon={false}
								/>
								<p>Viewing {(this.state.active && "Active Builders") || "All Builders"}</p>
							</div>
							<p className="infoNote">Please note this includes only lots assigned to a builder.  Lots can only be in counted once in either starts, completes, and closed.</p>
							<h3 className="pt-6">By Builder + Lot Type</h3>
							<FullTable
								data={this.buildTable()}
								columns={this.state.columns}
								name="constructionStatusBuilder"
								title="Construction Status Builder"
								classNames="small"
								unset={["edit"]}
								pageSize={20}
							/>
							<h3>By Lot Type</h3>
							<FullTable
								data={this.buildLotTypeTable()}
								columns={this.state.lotTypeColumns}
								name="constructionStatusLotType"
								title="Construction Status Lot Type"
								unset={["edit"]}
								classNames="small"
								pageSize={20}
							/>
						</div>
					</div>
				</div>
			)
		}
	}
}

function mapStateToProps(state) {
	return {
		currentDates: state.currentDates,
		compareDates: state.compareDates,
		payload: state.payload,
		payloadStatus: state.payloadStatus,
		activeProperties: state.activeProperties,
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators({}, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(HomeConstructionStatus)
